import PropTypes from 'prop-types';
import React from 'react';

import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';

import HelpPanelActions from '../HelpPanelActions';

import styles from './PortfolioHelpPanel.module.scss';

export const PortfolioHelpPanel = ({
  clientSupportEmail = '',
  liveChatEnabled = false,
  onStartTour,
}) => {
  const { t } = useImprovedTranslation();

  return (
    <aside className={styles.main} data-hook="portfolio-help-panel">
      <div className={styles.header}>
        <span>{t('Need Help?')}</span>
      </div>
      <div className={styles.content}>
        <p>
          {t(
            'If you need help getting verified, staying safe while playing, or have any other questions, our friendly support team is here for you.'
          )}
        </p>
        <p>
          {t(
            'You can also take a quick tour of the site to learn how to make the most of our platform.'
          )}
        </p>
        <HelpPanelActions
          clientSupportEmail={clientSupportEmail}
          liveChatEnabled={liveChatEnabled}
          onStartTour={onStartTour}
          dataHookPrefix="portfolio-help"
        />
      </div>
    </aside>
  );
};

PortfolioHelpPanel.propTypes = {
  clientSupportEmail: PropTypes.string,
  liveChatEnabled: PropTypes.bool,
  onStartTour: PropTypes.func.isRequired,
};

export const Component = PortfolioHelpPanel;

export default PortfolioHelpPanel;
